export enum ChannelSuffix {
    INITIAL = '',
    INCREMENTAL = '/incremental',
    CYCLICAL_UNIFIED = '/cyclical/unified',
    CYCLICAL_UNIFIED_ON_DEMAND = '/cyclical/unified_on_demand',
    CYCLICAL_BOOTSTRAP = '/cyclical/bootstrap',
    BOOTSTRAP = '/bootstrap',
    DELTA = '/delta'
}

export class SessionBehaviour {

    constructor(
        public initialChannelSuffix: ChannelSuffix,
        public subsequentChannelSuffix: ChannelSuffix | null
    ) {}

    static simple(): SessionBehaviour {
        return new SessionBehaviour(ChannelSuffix.INITIAL, null);
    }

    static incremental(): SessionBehaviour {
        return new SessionBehaviour(ChannelSuffix.INITIAL, ChannelSuffix.INCREMENTAL);
    }

    static cyclicalUnified(): SessionBehaviour {
        return new SessionBehaviour(ChannelSuffix.CYCLICAL_UNIFIED, null);
    }

    static cyclicalUnifiedOnDemand(): SessionBehaviour {
        return new SessionBehaviour(ChannelSuffix.CYCLICAL_UNIFIED_ON_DEMAND, null);
    }

    static cyclicalDelta(): SessionBehaviour {
        return new SessionBehaviour(ChannelSuffix.CYCLICAL_BOOTSTRAP, ChannelSuffix.DELTA);
    }

    static delta(): SessionBehaviour {
        return new SessionBehaviour(ChannelSuffix.BOOTSTRAP, ChannelSuffix.DELTA);
    }
}
